export default __webpack_public_path__ + "static/media/hello.27657d19.svg";